<section class="top-five">
    @if (title && title.length > 0) {
        <header class="head">
            <span class="marker" [style.background]="colour"></span>
            <div>
                <h4>{{title}}</h4>
                @if (subTitle) {<span class="sub">{{subTitle}}</span>}
            </div>
        </header>
    }

    @if (showAsTable) {
        <table>
            @if (includeComparison) {
                <thead>
                    <tr>
                        <th class="rank"></th>
                        <th></th>
                        <th class="num">{{before}}</th>
                        <th class="num">{{after}}</th>
                        <th class="num">Change</th>
                    </tr>
                </thead>
            }
            <tbody>
                @for (row of rows; track row._key; let i = $index) {
                    <tr (click)="selectRow(row)" [title]="row.tooltip || row.name">
                        <td class="rank">{{i + 1}}</td>
                        <td class="name">
                            <span class="label-row"><span class="label">{{row.name}}</span>@if (contextOrganisation && contextScope && row._key) {<app-context-graph-button [organisation]="contextOrganisation" [scope]="contextScope" [request]="{node: row._key}" [name]="row.name"></app-context-graph-button>}</span>
                            <!-- the row's share of the largest, so the five can be compared at a glance -->
                            <span class="bar"><span [style.width.%]="share(row)" [style.background]="colour"></span></span>
                        </td>
                        <td class="num value" [class.negative]="row.before < 0">
                            @if (row.currency) {
                                {{row.before | currency: currencyCode: 'symbol-narrow': '1.0-0'}}
                            }@else {
                                {{row.before | number}}
                            }
                        </td>
                        @if (includeComparison) {
                            <td class="num" [style.color]="row.compareColour">{{row.after | number}}</td>
                            <td class="num" [style.color]="row.compareColour">{{row.comparePercentage ? row.comparePercentage + '%' : '–'}}</td>
                        }@else if (includePercentages && row.percentage) {
                            <td class="num muted">{{row.percentage}}%</td>
                        }@else if (includeUnits && row.units) {
                            <td class="muted">{{row.units}}</td>
                        }
                    </tr>
                }@empty {
                    <tr class="empty"><td colspan="5">Nothing to show.</td></tr>
                }
            </tbody>
        </table>
    }@else {
        <app-bar-chart [data]="barData" (selectNodeEvent)="selectChart($event)" [stacks]="['']" indexAxis="y" [height]="chartHeight()" [hideLegend]="true"></app-bar-chart>
    }
</section>
